function convertDateFromYYYYMMDDinDDMMYYYY(date) {
    const array = date.split('-')
    return array[2] + '/' + array[1] + '/' + array[0]
}

function formatDateArrayInDDMMYYYY(date) {
    if (date && date.day && date.month && date.year) {
        return date.day + '/' + date.month + '/' + date.year
    }

    return ''
}

/**
 * Convertit un objet date {day: '10',month: '12',year: '1979'} provenant de nxtcms en 10/12/1979
 }
 * @param date
 */
const nxtcmsDateConverter = (date) => {
    if (date !== undefined && date.day && date.month && date.year) {
        return date.day + '/' + date.month + '/' + date.year
    }
    return null
}

export {
    convertDateFromYYYYMMDDinDDMMYYYY,
    formatDateArrayInDDMMYYYY,
    nxtcmsDateConverter
}
